import { Component, OnInit } from '@angular/core';
import Chart, { ChartConfiguration } from 'chart.js/auto';
import { ReportesService } from '../reportes.service';
import { AlertService, LoadingService } from 'ngx-kuv-tools';
import { FormatterService } from 'src/app/utils/formatter/formatter.service';
import { ProductoService } from '../../producto/producto.service';

@Component({
  selector: 'app-reportes-inventario',
  templateUrl: './reportes-inventario.component.html',
  styleUrls: ['./reportes-inventario.component.scss']
})
export class ReportesInventarioComponent implements OnInit {

  desde: string = '';
  hasta: string = '';
  productos: any[] = [];
  productosSelected: any[] = [];

  tipoVista: 1 | 2 | 3 = 1;
  filtroFecha: number | null = 1;

  data: any = {};

  chartStocks: any = null;
  chartConfigStocks: ChartConfiguration = {
    type: 'line',
    options: {
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: false
        },
        tooltip: {
          intersect: false
        }
      },
      interaction: {
        mode: 'index'
      }
    },
    data: {
      labels: [],
      datasets: [
        {
          label: 'Cantidad',
          data: []
        }
      ]
    }
  }

  chartComprasVentas: any = null;
  chartConfigComprasVentas: ChartConfiguration = {
    type: 'bar',
    options: {
      maintainAspectRatio: false,
      interaction: {
        mode: 'index'
      },
      plugins: {
        tooltip: {
          intersect: false
        }
      }
    },
    data: {
      labels: [],
      datasets: [
        {
          label: 'Ventas',
          data: []
        },
        {
          label: 'Compras',
          data: []
        },
      ]
    }
  }

  constructor(
    private service: ReportesService,
    private loading: LoadingService,
    private alerts: AlertService,
    public formatter: FormatterService,
    private productoService: ProductoService,
  ) { }

  ngOnInit(): void {
    this.loadProductos();
    this.setFiltroFecha(3);
  }

  loadProductos(){
    this.loading.show()
    this.productoService.select().subscribe({
      next: (res: any) => {
        this.loading.hide();
        this.productos = res.filter((e:any) => e.tipo == 1);
      }, error: (err: any) => {
        this.loading.hide();
        if(err.response) this.alerts.addAlert(err.response, 'danger');
      }
    });
  }

  loadData(){
    this.loading.show()
    this.service.inventario(this.desde, this.hasta, this.productosSelected).subscribe({
      next: (res: any) => {
        this.loading.hide();
        this.data = res;
        this.displayChart();
      }, error: (err: any) => {
        this.loading.hide();
        if(err.response) this.alerts.addAlert(err.response, 'danger');
      }
    });
  }

  displayChart(){
    if (this.chartStocks) this.chartStocks.destroy();
    let stocks = this.formatter.parseDataParaReporte(this.data.stocks, this.desde, this.hasta, this.tipoVista, 'cantidad', true);
    this.chartConfigStocks.data.labels = stocks.leyenda;
    this.chartConfigStocks.data.datasets[0].data = stocks.result;
    this.chartStocks = new Chart(
      <any>document.getElementById('stocks'),
      this.chartConfigStocks
    );
      
    if (this.chartComprasVentas) this.chartComprasVentas.destroy();
    let cantidades = this.formatter.parseDataParaReporte(this.data.cantidadVendida, this.desde, this.hasta, this.tipoVista, 'cantidad');
    let compras = this.formatter.parseDataParaReporte(this.data.compras, this.desde, this.hasta, this.tipoVista, 'cantidad');
    this.chartConfigComprasVentas.data.labels = cantidades.leyenda;
    this.chartConfigComprasVentas.data.datasets[0].data = cantidades.result;
    this.chartConfigComprasVentas.data.datasets[1].data = compras.result;
    this.chartComprasVentas = new Chart(
      <any>document.getElementById('compra-venta'),
      this.chartConfigComprasVentas
    );
  }

  searchFn(term: any, item: any) {
    const removeAccents = (str: any) => {
      return str.normalize("NFD").replace(/[̀-ͯ]/g, "");
    }
    let terms = removeAccents(term.toLowerCase()).split(' ');
    let result = true;
    let p = removeAccents(([item.nombre, item.sku, item.codigo_barra].join(' ')).toLowerCase());
    terms.forEach((t: any) => {
      result = result && p.includes(t);
    });
    return result;
  }

  setFiltroFecha(tipo: any = null) {
    this.filtroFecha = tipo;
    let result = this.formatter.obtenerFiltroFecha(tipo);

    this.desde = result.desde;
    this.hasta = result.hasta;
    this.loadData();
  }

}
